export const API_BASE_URL = 'https://booking-app-backend-5ion.onrender.com';
